"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const react_hooks_1 = require("@apollo/react-hooks");
const lodash_1 = require("lodash");
const utils_1 = require("../../utils");
const react_use_1 = require("react-use");
const context_1 = require("./context");
const Inner_1 = require("./Inner");
const react_hanger_1 = require("react-hanger");
const change_case_1 = require("change-case");
exports.OsmosysSelectBox = (props) => {
    const { pageSize = 50, skip, paths, selectFirstIfNoValue, onChange, value, resourceName, isOpen, variables, query, disabled, clearable = disabled === true ? false : undefined, boldLabel, fetchPolicy, } = props;
    const [input, setInput] = react_1.useState('');
    const [debouncedInput, setDebouncedInput] = react_1.useState('');
    const newQueryProps = {
        fetchPolicy,
        skip,
        variables: Object.assign(Object.assign({}, variables), { searchQuery: debouncedInput, skip: 0, take: pageSize }),
    };
    react_use_1.useDebounce(() => {
        setDebouncedInput(input);
    }, 1000, [input]);
    const result = react_hooks_1.useQuery(query, Object.assign({ fetchPolicy: 'cache-and-network' }, newQueryProps));
    const [options, count] = react_1.useMemo(() => {
        return [lodash_1.get(result.data, paths.list, []), lodash_1.get(result.data, paths.count, 0)];
    }, [result.data, paths, debouncedInput]);
    const hasOptions = options.length > 0;
    const previouslyHasOptions = react_hanger_1.usePrevious(hasOptions);
    const [hasMore, remainingAmount] = react_1.useMemo(() => {
        return [options.length < count, count - options.length];
    }, [options, count]);
    const isLoading = utils_1.queryIsLoading(result);
    const [loadingBuffer, toggleLoadingBuffer] = react_use_1.useToggle(false);
    // Turn off loading buffer after a beat:
    react_1.useEffect(() => {
        if (loadingBuffer) {
            const t = setTimeout(() => {
                toggleLoadingBuffer(false);
            }, 500);
            return () => {
                clearTimeout(t);
            };
        }
        return () => { };
    }, [loadingBuffer, toggleLoadingBuffer]);
    react_1.useEffect(() => {
        if (selectFirstIfNoValue &&
            hasOptions &&
            hasOptions !== previouslyHasOptions) {
            if (!value) {
                onChange(options[0]);
            }
        }
    }, [hasOptions, previouslyHasOptions]);
    const prettyResourceName = react_1.useMemo(() => {
        return {
            noCase: change_case_1.noCase(resourceName),
            sentenceCase: change_case_1.sentenceCase(resourceName),
            title: change_case_1.title(resourceName),
        };
    }, [resourceName]);
    const showAsLoadingState = loadingBuffer || isLoading;
    return (react_1.default.createElement(context_1.OsmosysSelectBoxContext.Provider, { value: Object.assign(Object.assign({}, props), { boldLabel,
            clearable,
            count,
            disabled,
            // queryProps: newQueryProps,
            hasMore,
            input,
            isOpen,
            onChange,
            options,
            pageSize,
            paths,
            prettyResourceName,
            remainingAmount,
            resourceName,
            result,
            selectFirstIfNoValue,
            setInput,
            showAsLoadingState,
            toggleLoadingBuffer,
            value, variables: newQueryProps.variables }) },
        react_1.default.createElement(Inner_1.OsmosysSelectBoxInner, null)));
};
//# sourceMappingURL=index.js.map